import { render, staticRenderFns } from "./LandChange.vue?vue&type=template&id=6c2c99f3&scoped=true&"
import script from "./LandChange.vue?vue&type=script&lang=js&"
export * from "./LandChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c99f3",
  null
  
)

export default component.exports